import React from 'react'

import { AcornsIcon } from '@acorns/icons'
import { useRemoteStrings } from '@acorns/web-utils'

import { TABLE_OF_CONTENT_GROW_LEAF_TIP } from 'utils/testing/testIDs'

import {
  GrowLeafContainer,
  GrowLeafIcon,
  GrowLeafIconWrapper,
  GrowLeafText,
} from './styled-components'

const GrowLeafTip = (): React.ReactElement => {
  const { getRemoteString } = useRemoteStrings()

  return (
    <GrowLeafContainer data-testid={TABLE_OF_CONTENT_GROW_LEAF_TIP}>
      <GrowLeafIconWrapper>
        <GrowLeafIcon icon={AcornsIcon.Icon.ProductGrowFv} width={24} />
      </GrowLeafIconWrapper>
      <GrowLeafText>
        {getRemoteString({
          key: 'early.recap.table_of_contents.footer.description',
        })}
      </GrowLeafText>
    </GrowLeafContainer>
  )
}

export { GrowLeafTip }
